// extracted by mini-css-extract-plugin
export default {"previewContainer":"ProjectPreview_previewContainer__tU8OV","details":"ProjectPreview_details__srq+c","invisible":"ProjectPreview_invisible__Amcai"};